// src/pages/Home.jsx
// import React from "react";
// import React, { useState } from "react";
  import React, { useState, useEffect } from "react";
  import { Modal } from "react-bootstrap";
  import SEO from "../components/seo";

import Slider from "react-slick";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";


import HeroSlider from "./HeroSlider";
import Header from "../components/header";
import Footer from "../components/footer";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


// ✅ Move this here — after all imports
const ASSETS_ROOT = process.env.PUBLIC_URL + "/assets";


const testimonials = [
  {
    id: 1,
    quote:
      "From ensuring seamless international shipments to providing efficient domestic deliveries, our clients commend our ability to handle their logistics challenges with precision and care.",
    name: "Alesha Healy",
    role: "Cargon Operator",
    img: "static/img/testimonial/ca-testimonial4.1.webp",
  },
  {
    id: 2,
    quote:
      "We take pride in the positive feedback we receive from businesses across various industries who rely on our expertise to meet their logistics needs. Our clients consistently highlight our reliability.",
    name: "Virginia Dea",
    role: "Cargon Operator",
    img: "static/img/testimonial/ca-testimonial4.2.webp",
  },
  {
    id: 3,
    quote:
      "From ensuring seamless international shipments to providing efficient domestic deliveries, our clients commend our ability to handle their logistics challenges with precision and care.",
    name: "Alesha Healy",
    role: "Cargon Operator",
    img: "static/img/testimonial/ca-testimonial4.1.webp",
  },
];

const sliderSettings = {
  dots: false,
  infinite: true,
  speed: 5000,
  slidesToShow: 5,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  cssEase: "linear",
  responsive: [
    {
      breakpoint: 1200,
      settings: { slidesToShow: 4 }
    },
    {
      breakpoint: 768,
      settings: { slidesToShow: 3 }
    },
    {
      breakpoint: 480,
      settings: { slidesToShow: 2 }
    }
  ]
};

const logos1 = [
  "static/img/brand/brand-1.webp",
  "static/img/brand/brand-2.webp",
  "static/img/brand/brand-3.webp",
  "static/img/brand/brand-4.webp",
  "static/img/brand/brand-5.webp",
  "static/img/brand/brand-6.webp",
  "static/img/brand/brand-3.webp",
];

const logos2 = [
  "static/img/brand/brand-1.1.webp",
  "static/img/brand/brand-1.2.webp",
  "static/img/brand/brand-1.3.webp",
  "static/img/brand/brand-1.4.webp",
  "static/img/brand/brand-1.5.webp",
  "static/img/brand/brand-1.6.webp",
  "static/img/brand/brand-1.4.webp",
  "static/img/brand/brand-1.3.webp",
  "static/img/brand/brand-1.2.webp",
];

function Home() {
  // MODAL STATES
const [showModal, setShowModal] = useState(false);
const [modalContent, setModalContent] = useState({ title: "Newsletter" });

// Popup Form States
const [popupFormData, setPopupFormData] = useState({
  name: "",
  phone: "",
  message: ""
});

const [popupLoading, setPopupLoading] = useState(false);
const [popupResponseMsg, setPopupResponseMsg] = useState("");



    // SHOW MODAL ON LOAD
  // useEffect(() => {
  //   setModalContent({ title: "Newsletter" });
  //   setShowModal(true);
  // }, []);


  useEffect(() => {
  const timer = setTimeout(() => {
    setModalContent({ title: "Newsletter" });
    setShowModal(true);
  }, 8000); // 8 seconds delay

  return () => clearTimeout(timer);
}, []);


  // FORM SUBMIT popup
  const handlePopupSubmit = async (e) => {
  e.preventDefault();
  setPopupLoading(true);
  setPopupResponseMsg("");

  try {
    const payload = { ...popupFormData };

    const res = await fetch("/contact_api/popup_contact.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    });

    const result = await res.json();
    setPopupResponseMsg(result.message);

    if (result.status === "success") {
      setPopupFormData({ name: "", phone: "", message: "" });
      setShowModal(false);
    }
  } catch (error) {
    setPopupResponseMsg("API Error: " + error.message);
  } finally {
    setPopupLoading(false);
  }
};



  const [formData, setFormData] = useState({
     first_name: "",
    //  last_name: "",
     email: "",
     number: "",      
     service_type: "",
     message: "",
     save_info: false,
   });
 
   const [responseMsg, setResponseMsg] = useState(""); // message display ke liye
   const [loading, setLoading] = useState(false);     // loading state
 
   // Input change handle
   const handleChange = (e) => {
     const { name, value, type, checked } = e.target;
     setFormData({
       ...formData,
       [name]: type === "checkbox" ? checked : value,
     });
   };
 
   // Submit API
   const handleSubmit = async (e) => {
     e.preventDefault();
     setLoading(true);
     setResponseMsg("");

       setLoading(true); 
      setResponseMsg("");

      // Phone number validation
      if (!formData.number || formData.number.length !== 10) {
        setResponseMsg("Phone number must be exactly 10 digits.");
        setLoading(false); 
        return;
      }
     
 
     try {
       // Convert checkbox boolean to 0/1 for PHP
       const payload = { ...formData, save_info: formData.save_info ? 1 : 0 };
 
       const res = await fetch("https://karmyogienterprise.com/contact_api/insert_contact.php", {
         method: "POST",
         headers: {
           "Content-Type": "application/json"
         },
         body: JSON.stringify(payload)
       });
 
       const result = await res.json();
 
       setResponseMsg(result.message);
 
       // Reset form if successful
       if (result.status === "success") {
         setFormData({
           first_name: "",
           last_name: "",
           email: "",
           number: "",    
           service_type: "",
           message: "",
           save_info: false,
         });
       }
     } catch (error) {
       setResponseMsg("API Error: " + error.message);
     } finally {
       setLoading(false);
     }
   };



 
  return (

    <>
     {/* <SEO page="home" /> */}
      <SEO pageKey="home" />
    <main>
      {/*slider start */}
      <HeroSlider />
      {/* slider end */}
      {/* about section start */}
      <section className="ca-about-3 pt-100 pb-70">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="ca-abo-item-1 hide-m">
                <div className="row">
                  <div className="col-lg-6 col-md-6">
                    {/* single about item */}
                    <div className="ca-abo-single-item mb-30">
                      <img
                        className="w-100 lar-img-1"
                        src="static/img/about/ca-about3.1.webp"
                        alt=""
                      />
                      <div className="ca-abo-hover-item">
                        <div className="ca-abo-content">
                          <div className="ca-abo-icon">
                            <span>
                              <img
                                src="static/img/icon/ca-delivery3.1.svg"
                                alt=""
                              />
                            </span>
                          </div>
                          <h3 className="ca-abo-hover-title">
                            <span className="counter">100</span>+
                          </h3>
                          <p>Product Range</p>
                        </div>
                      </div>
                    </div>
                    {/* single about item */}
                    <div className="ca-abo-single-item mb-30">
                      <img
                        className="w-100 sm-img-1"
                        src="static/img/about/ca-delivery32.webp"
                        alt=""
                      />
                      <div className="ca-abo-hover-item">
                        <div className="ca-abo-content">
                          <div className="ca-abo-icon">
                            <span>
                              <img
                                src="static/img/icon/ca-delivery3.1.svg"
                                alt=""
                              />
                            </span>
                          </div>
                          <h3 className="ca-abo-hover-title">
                            <span className="counter">500</span>+
                          </h3>
                          <p>Satisfied Clients</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    {/* single about item */}
                    <div className="ca-abo-single-item mb-30">
                      <img
                        className="w-100 sm-img-2"
                        src="static/img/about/ca-sm-about-3.2.webp"
                        alt=""
                      />
                      <div className="ca-abo-hover-item">
                        <div className="ca-abo-content">
                          <div className="ca-abo-icon">
                            <span>
                              <img
                                src="static/img/icon/ca-delivery3.1.svg"
                                alt=""
                              />
                            </span>
                          </div>
                          <h3 className="ca-abo-hover-title">
                            <span className="counter">10</span>
                          </h3>
                          <p>Years of experience</p>
                        </div>
                      </div>
                    </div>
                    {/* single about item */}
                    <div className="ca-abo-single-item mb-30">
                      <img
                        className="w-100 lar-img-2"
                        src="static/img/about/ca-about-3.3.webp"
                        alt=""
                      />
                      <div className="ca-abo-hover-item">
                        <div className="ca-abo-content">
                          <div className="ca-abo-icon">
                            <span>
                              <img
                                src="static/img/icon/ca-delivery3.1.svg"
                                alt=""
                              />
                            </span>
                          </div>
                          <h3 className="ca-abo-hover-title">
                            <span className="counter">200</span>
                          </h3>
                          <p>Projects Completed</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-6 mb-30">
              <div className="ca-ab-content3">
                <div className="ca-about-content-3 ca-sec-content-3">
                  <h5 className="ca-section-subtitle subtitle-bg-6 p-relative theme-color-3 br-50">
                    Why We Are
                  </h5>
                  <h2 className="ca-section-title theme-black-3 fnw-600 pt-16 ca-text-cap">
                    Diligent Supply of <br />High-Quality <br /> Copper Materials
                  </h2>
                  <p className="pt-16 pb-32">
                    {" "}
                    Karmyogi Enterprise is a dedicated and reliable firm specializing in the supply of high-quality copper piping and essential fittings parts. We serve as a crucial link in the industrial and commercial supply chain, ensuring our clients receive robust, standard-compliant materials necessary for critical applications like HVAC, plumbing, and refrigeration. Committed to the principle of diligent work (Karmyogi), our mission is to provide consistent quality, competitive pricing, and efficient logistics, making us the trusted partner for all your copper pipe and fittings requirements.
                    <br /> <br />
                    We serve as a reliable supply partner, ensuring that our inventory consists of materials that offer superior thermal conductivity, corrosion resistance, and dimensional accuracy. Our commitment, inspired by the principle of 'Karmyogi' (diligent action), is to equip contractors, manufacturers, and maintenance teams with the robust copper solutions required to build, maintain, and upgrade critical infrastructure efficiently and safely.
                  </p>
                </div>
                <div className="ca-ab-item-check">
                  {/* single-item */}
                  {/* <div className="ca-ab-sngle-item">
                    <div className="ca-ab-sngle-item-ic">
                      <span>
                        <i className="fa-solid fa-check" />
                      </span>
                    </div>
                    <div className="ca-ab-sngle-item-content">
                      <h4 className="ca-item-ch-title">
                        Experts in Logistics Management
                      </h4>
                    </div>
                  </div> */}
                  {/* single-item */}
                  {/* <div className="ca-ab-sngle-item">
                    <div className="ca-ab-sngle-item-ic">
                      <span>
                        <i className="fa-solid fa-check" />
                      </span>
                    </div>
                    <div className="ca-ab-sngle-item-content">
                      <h4 className="ca-item-ch-title">
                        Leaders in Global Logistics
                      </h4>
                    </div>
                  </div> */}
                  {/* single-item */}
                  {/* <div className="ca-ab-sngle-item">
                    <div className="ca-ab-sngle-item-ic">
                      <span>
                        <i className="fa-solid fa-check" />
                      </span>
                    </div>
                    <div className="ca-ab-sngle-item-content">
                      <h4 className="ca-item-ch-title">
                        Transforming Transport &amp; Logistics
                      </h4>
                    </div>
                  </div> */}
                  {/* single-item */}
                  {/* <div className="ca-ab-sngle-item">
                    <div className="ca-ab-sngle-item-ic">
                      <span>
                        <i className="fa-solid fa-check" />
                      </span>
                    </div>
                    <div className="ca-ab-sngle-item-content">
                      <h4 className="ca-item-ch-title">
                        Driving Logistics Success
                      </h4>
                    </div>
                  </div> */}
                </div>
                {/* <div className="ca-about-item3 cream-bg-3 p-relative">
                  <p>
                    We are driving success and creating opportunities for growth.
                    Discover <br />
                    difference with a logistics partner that is truly invested in
                    your success.
                  </p>
                </div> */}
                {/* <div className="ca-about-3-btn">
                  <a
                    href="#"
                    className="ca-btn-primary-3 theme-bg-3 text-white br-50"
                  >
                    Transpires
                    <span>
                      <i className="fa-solid fa-angle-right" />
                    </span>
                  </a>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* about section end */}


      {/* service section start */}
      {/* <section className="ca-service-3 cream-bg-3 pt-100 pb-70"> */}
      {/* <div className="container">
          <div
            className="ca-portfolio-content-3 ca-sec-content-3 text-center mb-60 aos-init aos-animate"
            data-aos="fade-up"
            data-aos-duration={800}
          >
            <h5 className="ca-section-subtitle subtitle-bg-6 p-relative theme-color-3 br-50">
              Our Service
            </h5>
            <h2 className="ca-section-title theme-black-3 fnw-600 pt-16 ca-text-cap">
              Our Range of Logistics Services
            </h2>
            <p className="pt-16">
              Our state-of-the-art facilities and innovative technology support
              e-commerce
              <br />
              fulfillment and project cargo handling, providing you with tailored
              solutions.
            </p>
          </div>
        </div> */}
      {/* expand gallery start */}
      {/* <div className="expand-container"> */}
      {/* single item */}
      {/* <div className="slide">
            <img
              className="expand-slide-img"
              src="static/img/service/ca-expand-gallery3.1.webp"
              alt=""
            />
            <div className="expand-slide-ic-box">
              <div className="ca-expand-ic">
                <span>
                  <img
                    src="static/img/icon/ca-expand-ic3.1.svg"
                    alt=""
                  />
                </span>
              </div>
              <h2 className="ca-expand-title">
                <a href="#">Supply Chain Management</a>
              </h2>
              <p>
                From freight forwarding &amp; customs brokerage to warehousing
                solutions and supply chain management, our expertise ensures that
                your logistics operations are seamless and efficient.
              </p>
            </div>
          </div> */}
      {/* single item */}
      {/* <div className="slide">
            <img
              className="expand-slide-img"
              src="static/img/service/ca-expand-gallery3.2.webp"
              alt=""
            />
            <div className="expand-slide-ic-box">
              <div className="ca-expand-ic">
                <span>
                  <img
                    src="static/img/icon/ca-expand-ic3.1.svg"
                    alt=""
                  />
                </span>
              </div>
              <h2 className="ca-expand-title">
                <a href="#">Supply Chain Management</a>
              </h2>
              <p>
                From freight forwarding &amp; customs brokerage to warehousing
                solutions and supply chain management, our expertise ensures that
                your logistics operations are seamless and efficient.
              </p>
            </div>
          </div> */}
      {/* single item */}
      {/* <div className="slide">
            <img
              className="expand-slide-img"
              src="static/img/service/ca-expand-gallery3.3.webp"
              alt=""
            />
            <div className="expand-slide-ic-box">
              <div className="ca-expand-ic">
                <span>
                  <img
                    src="static/img/icon/ca-expand-ic3.1.svg"
                    alt=""
                  />
                </span>
              </div>
              <h2 className="ca-expand-title">
                <a href="#">Supply Chain Management</a>
              </h2>
              <p>
                From freight forwarding &amp; customs brokerage to warehousing
                solutions and supply chain management, our expertise ensures that
                your logistics operations are seamless and efficient.
              </p>
            </div>
          </div> */}
      {/* single item */}
      {/* <div className="slide active">
            <img
              className="expand-slide-img"
              src="static/img/service/ca-expand-gallery3.1.webp"
              alt=""
            />
            <div className="expand-slide-ic-box">
              <div className="ca-expand-ic">
                <span>
                  <img
                    src="static/img/icon/ca-expand-ic3.1.svg"
                    alt=""
                  />
                </span>
              </div>
              <h2 className="ca-expand-title">
                <a href="#">Supply Chain Management</a>
              </h2>
              <p>
                From freight forwarding &amp; customs brokerage to warehousing
                solutions and supply chain management, our expertise ensures that
                your logistics operations are seamless and efficient.
              </p>
            </div>
          </div> */}
      {/* single item */}
      {/* <div className="slide">
            <img
              className="expand-slide-img"
              src="static/img/service/ca-expand-gallery3.2.webp"
              alt=""
            />
            <div className="expand-slide-ic-box">
              <div className="ca-expand-ic">
                <span>
                  <img
                    src="static/img/icon/ca-expand-ic3.1.svg"
                    alt=""
                  />
                </span>
              </div>
              <h2 className="ca-expand-title">
                <a href="#">Supply Chain Management</a>
              </h2>
              <p>
                From freight forwarding &amp; customs brokerage to warehousing
                solutions and supply chain management, our expertise ensures that
                your logistics operations are seamless and efficient.
              </p>
            </div>
          </div>
        </div> */}
      {/* expand gallery end */}
      {/* </section> */}
      {/* service section end */}



        {/* sections  */}
    {/* <div className="container">
      <div
            className="ca-portfolio-content-3 ca-sec-content-3 text-center mb-60 aos-init aos-animate"
            data-aos="fade-up"
            data-aos-duration={800}
          >
            <h5 className="ca-section-subtitle subtitle-bg-6 p-relative theme-color-3 br-50">
              Our Projects
            </h5>
            <h2 className="ca-section-title theme-black-3 fnw-600 pt-16">
              Product Application Sectors
            </h2>
            <p className="pt-16">
              {" "}
              Powering Industries with Quality Copper Products{" "}
             
            </p>
          </div>
      <div className="row">
        <div className="col-xl-3 col-md-6">
          <div
            className="ca-single-portfolio-item sm-img p-relative z-index-1 fix mb-30"
            data-category="transport" >
            <div className="ca-portfolio-img">
              <img
                className="w-100 br-7"
                src="/static/img/portfolio/Product_Foil.webp"
                alt=""
              />
            </div>
            <div className="ca-portfolio-link">
              <a href="/copper_foil_list" className="portfolio-link portfolio-link-2">
                <span>
                  <img
                    src="/static/img/icon/ca-portfolio-arrow-1.1.svg"
                    alt=""
                  />
                </span>
              </a>
            </div>
            <div className="ca-portfolio-content-meta theme-bg-3 br-7">
              <h4 className="ca-por-title">
                <a href="/copper_foil_list">Copper Foil List</a>
              </h4>
            </div>
          </div> 
        </div>
        <div className="col-xl-3 col-md-6">
          <div
            className="ca-single-portfolio-item sm-img p-relative z-index-1 fix mb-30"
            data-category="transport"
          >
            <div className="ca-portfolio-img">
              <img
                className="w-100 br-7"
                src="/static/img/portfolio/Product_Pipe.webp"
                alt=""
              />
            </div>
            <div className="ca-portfolio-link">
              <a href="/copper_straight_pipe_list" className="portfolio-link portfolio-link-2">
                <span>
                  <img
                    src="/static/img/icon/ca-portfolio-arrow-1.1.svg"
                    alt=""
                  />
                </span>
              </a>
            </div>
            <div className="ca-portfolio-content-meta theme-bg-3 br-7">
              <h4 className="ca-por-title">
                <a href="/copper_straight_pipe_list">Copper Straigth Pipe</a>
              </h4>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-md-6">
          <div
            className="ca-single-portfolio-item sm-img p-relative z-index-1 fix mb-30"
            data-category="transport"
          >
            <div className="ca-portfolio-img">
              <img
                className="w-100 br-7"
                src="/static/img/portfolio/Product_Pancake.webp"
                alt=""
              />
            </div>
            <div className="ca-portfolio-link">
              <a href="/copper_pancake_list" className="portfolio-link portfolio-link-2">
                <span>
                  <img
                    src="/static/img/icon/ca-portfolio-arrow-1.1.svg"
                    alt=""
                  />
                </span>
              </a>
            </div>
            <div className="ca-portfolio-content-meta theme-bg-3 br-7">
              <h4 className="ca-por-title">
                <a href="/copper_pancake_list">Copper Pancake</a>
              </h4>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-md-6">
          <div
            className="ca-single-portfolio-item sm-img p-relative z-index-1 fix mb-30"
            data-category="transport"
          >
            <div className="ca-portfolio-img">
              <img
                className="w-100 br-7"
                src="/static/img/portfolio/Product_U.webp"
                alt=""
              />
            </div>
            <div className="ca-portfolio-link">
              <a href="/copper_fitting_list" className="portfolio-link portfolio-link-2">
                <span>
                  <img
                    src="/static/img/icon/ca-portfolio-arrow-1.1.svg"
                    alt=""
                  />
                </span>
              </a>
            </div>
            <div className="ca-portfolio-content-meta theme-bg-3 br-7">
              <h4 className="ca-por-title">
                <a href="/copper_fitting_list">copper fittings</a>
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div> */}

{/* sections  */}
    <section className="ca-team pt-100 pb-70 pro-100">
      <div className="container">
         <div
            className="ca-portfolio-content-3 ca-sec-content-3 text-center mb-60 aos-init aos-animate"
            data-aos="fade-up"
            data-aos-duration={800}
          >
            <h5 className="ca-section-subtitle subtitle-bg-6 p-relative theme-color-3 br-50">
              Products Range
            </h5>
            <h2 className="ca-section-title theme-black-3 fnw-600 pt-16">
              Our Products
            </h2>
            <p className="pt-16">
              {" "}
              Extensive selection of copper products for various industrial uses{" "}
             
            </p>
          </div>
        <div className="row">
          {/* single team item */}
          <div className="col-lg-3 col-md-6">
            <div
              className="ca-single-team-box mb-30 aos-init aos-animate"
              data-aos="fade-right"
              data-aos-duration={800}
            >
              
              <div className="ca-single-team-img">
                <a href="/level_wound_coil_list">
                  <img className="w-100" src="/static/img/portfolio/Product_Tube_LWC.webp" alt="" />
                </a>
              </div>
              <div className="ca-single-team-content">
                <h3 className="ca-team-title">
                  <a href="/level_wound_coil_list">Level Wound Coil (LWC)</a>
                </h3>
                {/* <span>Chief Engineer</span> */}
              </div>
             
            </div>
          </div>
          {/* single team item */}
          <div className="col-lg-3 col-md-6">
            <div
              className="ca-single-team-box mb-30 aos-init aos-animate"
              data-aos="fade-right"
              data-aos-duration={800}
            >
              
              <div className="ca-single-team-img">
                <a href="/copper_foil_list">
                  <img className="w-100" src="/static/img/portfolio/Product_Foil.webp" alt="" />
                </a>
              </div>
              <div className="ca-single-team-content">
                <h3 className="ca-team-title">
                  <a href="/copper_foil_list">Copper Foil</a>
                </h3>
                {/* <span>Chief Engineer</span> */}
              </div>
             
            </div>
          </div>
          {/* single team item */}
          <div className="col-lg-3 col-md-6">
            <div
              className="ca-single-team-box mb-30 aos-init aos-animate"
              data-aos="fade-right"
              data-aos-duration={800}
            >
              
              <div className="ca-single-team-img">
                <a href="/copper_straight_pipe_list">
                  <img className="w-100" src="/static/img/portfolio/Product_Pipe.webp" alt="" />
                </a>
              </div>
              <div className="ca-single-team-content">
                <h3 className="ca-team-title">
                  <a href="/copper_straight_pipe_list">Copper Straigth Pipe</a>
                </h3>
                {/* <span>Chief Engineer</span> */}
              </div>
             
            </div>
          </div>
          {/* single team item */}
          <div className="col-lg-3 col-md-6">
            <div
              className="ca-single-team-box mb-30 aos-init aos-animate"
              data-aos="fade-right"
              data-aos-duration={800}
            >
              
              <div className="ca-single-team-img">
                <a href="/copper_pancake_list">
                  <img className="w-100" src="/static/img/portfolio/Product_Pancake.webp" alt="" />
                </a>
              </div>
              <div className="ca-single-team-content">
                <h3 className="ca-team-title">
                  <a href="/copper_pancake_list">Copper Pancake</a>
                </h3>
                {/* <span>Chief Engineer</span> */}
              </div>
             
            </div>
          </div>
          {/* single team item */}
          <div className="col-lg-3 col-md-6">
            <div
              className="ca-single-team-box mb-30 aos-init aos-animate"
              data-aos="fade-right"
              data-aos-duration={800}
            >
              
              <div className="ca-single-team-img">
                <a href="/copper_fitting_list">
                  <img className="w-100" src="/static/img/portfolio/Product_C.webp" alt="" />
                </a>
              </div>
              <div className="ca-single-team-content">
                <h3 className="ca-team-title">
                  <a href="/copper_fitting_list">Copper Fittings</a>
                </h3>
                {/* <span>Chief Engineer</span> */}
              </div>
             
            </div>
          </div>
        </div>
      </div>
    </section>


      {/* portfolio section start */}
      <section className="ca-portfilo-2 pt-100 pb-70 pt-100-n hide-m">
        <div className="container">
          <div
            className="ca-portfolio-content-3 ca-sec-content-3 text-center mb-60 aos-init aos-animate"
            data-aos="fade-up"
            data-aos-duration={800}
          >
            <h5 className="ca-section-subtitle subtitle-bg-6 p-relative theme-color-3 br-50">
              Use Cases
            </h5>
            <h2 className="ca-section-title theme-black-3 fnw-600 pt-16">
              Application Industries
            </h2>
            <p className="pt-16">
              {" "}
              We Supply Our Products to Following Industries{" "}
              {/* <br />
              our success stories highlight our commitment to reliability. */}
            </p>
          </div>
          <div className="row">
            {/* single project item */}
            <div className="col-lg-3 col-md-6">
              <div className="ca-single-pro-img-3 mb-30">
                <img
                  className="w-100"
                  src="/static/img/portfolio/ca-portfoli3.1.webp"
                  alt=""
                />
                <div className="ca-project-hover-item1">
                  <a className="ca-project-hover-item1-icon">
                    <span>
                      <img
                        src="/static/img/icon/ca-arow-3.1.svg"
                        alt=""
                      />
                    </span>
                  </a>
                  <div className="ca-project-hover-item-content">
                    {/* <h4 className="ca-project-hov-sub-title">Transportation</h4> */}<br />
                    <h3 className="ca-project-hov-title">
                      <span className="ai_title">Chemical & Oil Refineries</span>
                    </h3>
                    {/* <p>
                      Explore our case studies achievements
                      <br /> to see how we have transformed.
                    </p> */}
                  </div>
                </div>
              </div>
            </div>
            {/* single project item */}
            <div className="col-lg-4 col-md-6">
              <div className="ca-single-pro-img-3 mb-30">
                <img
                  className="w-100"
                  src="/static/img/portfolio/ca-portfolio3.2.webp"
                  alt=""
                />
                <div className="ca-project-hover-item1">
                  <a className="ca-project-hover-item1-icon">
                    <span>
                      <img
                        src="static/img/icon/ca-arow-3.1.svg"
                        alt=""
                      />
                    </span>
                  </a>
                  <div className="ca-project-hover-item-content">
                    {/* <h4 className="ca-project-hov-sub-title">Transportation</h4> */}<br />
                    <h3 className="ca-project-hov-title">
                      <span className="ai_title">Pharmaceutical Companies</span>
                    </h3>
                    {/* <p>
                      Explore our case studies achievements
                      <br /> to see how we have transformed.
                    </p> */}
                  </div>
                </div>
              </div>
            </div>
            {/* single project item */}
            <div className="col-lg-5 col-md-6">
              <div className="ca-single-pro-img-3 mb-30">
                <img
                  className="w-100"
                  src="static/img/portfolio/ca-portfoli3.3.webp"
                  alt=""
                />
                <div className="ca-project-hover-item1">
                  <a className="ca-project-hover-item1-icon">
                    <span>
                      <img
                        src="static/img/icon/ca-arow-3.1.svg"
                        alt=""
                      />
                    </span>
                  </a>
                  <div className="ca-project-hover-item-content">
                    {/* <h4 className="ca-project-hov-sub-title">Transportation</h4> */}<br />
                    <h3 className="ca-project-hov-title">
                      <span className="ai_title">Air Conditioner Refrigerator</span>
                    </h3>
                    {/* <p>
                      Explore our case studies achievements
                      <br /> to see how we have transformed.
                    </p> */}
                  </div>
                </div>
              </div>
            </div>
            {/* single project item */}
            <div className="col-lg-6 col-md-6">
              <div className="ca-single-pro-img-3 mb-30">
                <img
                  className="w-100 pro-lar-img-1"
                  src="static/img/portfolio/ca-project3.4.webp"
                  alt=""
                />
                <div className="ca-project-hover-item1">
                  <a className="ca-project-hover-item1-icon">
                    <span>
                      <img
                        src="static/img/icon/ca-arow-3.1.svg"
                        alt=""
                      />
                    </span>
                  </a>
                  <div className="ca-project-hover-item-content">
                    {/* <h4 className="ca-project-hov-sub-title">Transportation</h4> */}<br />
                    <h3 className="ca-project-hov-title">
                      <span className="ai_title">Power Generation & Atomic Energy</span>
                    </h3>
                    {/* <p>
                      Explore our case studies achievements
                      <br /> to see how we have transformed.
                    </p> */}
                  </div>
                </div>
              </div>
            </div>
            {/* single project item */}
            <div className="col-lg-6 col-md-6">
              <div className="ca-single-pro-img-3 mb-30">
                <img
                  className="w-100 pro-lar-img-1"
                  src="static/img/portfolio/ca-portfolio-3.5.webp"
                  alt=""
                />
                <div className="ca-project-hover-item1">
                  <a className="ca-project-hover-item1-icon">
                    <span>
                      <img
                        src="static/img/icon/ca-arow-3.1.svg"
                        alt=""
                      />
                    </span>
                  </a>
                  <div className="ca-project-hover-item-content">
                    {/* <h4 className="ca-project-hov-sub-title">Transportation</h4> */}<br />
                    <h3 className="ca-project-hov-title">
                      <span className="ai_title">Food Processing & Water Coolers</span>
                    </h3>
                    {/* <p>
                      Explore our case studies achievements
                      <br /> to see how we have transformed.
                    </p> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* portfolio section end */}


      {/* video area start */}
      {/* <section className="video-play-section">
        <div className="container">
          <div className="ca-video-img br-7 p-relative z-index-1">
            <img
              className="w-100"
              src="static/img/service/v-play.webp"
              alt=""
            />
            <a
              href="https://www.youtube.com/watch?v=HkYGxh1XUGQ"
              className="video-play-button popup-video"
            >
              <span>
                <i className="fa-solid fa-play" />
              </span>
            </a>
            <div className="ca-counter-3 p-absolute"> */}
      {/* single counter area */}
      {/* <div className="ca-counter-area-3">
                <h3 className="ca-counter-title text-white fnw-700 pb-12">
                  <span className="counter">65</span>%
                </h3>
                <p>Air Freight</p>
              </div> */}
      {/* single counter area */}
      {/* <div className="ca-counter-area-3">
                <h3 className="ca-counter-title text-white fnw-700 pb-12">
                  <span className="counter">49</span>%
                </h3>
                <p>Land Freight</p>
              </div> */}
      {/* single counter area */}
      {/* <div className="ca-counter-area-3">
                <h3 className="ca-counter-title text-white fnw-700 pb-12">
                  <span className="counter">51</span>%
                </h3>
                <p>Shipping Service</p>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      {/* video area end */}


      {/* working section start */}
      {/* <div className="ca-working-section theme-black-bg-3 pt-390 pb-70">
        <div className="container">
          <div
            className="ca-working-section-3 ca-sec-content-3 text-center mb-60 aos-init aos-animate"
            data-aos="fade-up"
            data-aos-duration={800}
          >
            <h5 className="ca-section-subtitle subtitle-bg-7 p-relative text-white br-50">
              Working Process
            </h5>
            <h2 className="ca-section-title theme-black-3 fnw-600 text-white pt-16">
              Efficient Working Process
            </h2>
            <p className="pt-16">
              {" "}
              our working process is designed to deliver efficient, reliable, &amp;
              tailored
              <br />
              logistics solutions. From the initial consultation to the final
              delivery,
            </p>
          </div>
          <div className="row"> */}
      {/* working icon box */}
      {/* <div className="col-xl-3 col-lg-4 col-md-6 mb-30">
              <div
                className="ca-work-ic-box br-7 aos-init aos-animate"
                data-aos="fade-up"
                data-aos-duration={800}
              >
                <div className="ca-work-ic-box-img">
                  <span>
                    <img
                      src="static/img/icon/ca-work-1.1.svg"
                      alt=""
                    />
                  </span>
                </div>
                <div className="ca-work-ic-box-content">
                  <h4 className="ca-title fnw-600 text-white pt-24 pb-16">
                    <a href="/service-single">Coordination &amp; Execution</a>
                  </h4>
                  <p>
                    We then coordinate &amp; manage all aspects of transportation,{" "}
                    <br />
                    leveraging our global network.
                  </p>
                </div>
              </div>
            </div> */}
      {/* working icon box */}
      {/* <div className="col-xl-3 col-lg-4 col-md-6 mb-30">
              <div
                className="ca-work-ic-box br-7 aos-init aos-animate"
                data-aos="fade-up"
                data-aos-duration={1000}
              >
                <div className="ca-work-ic-box-img">
                  <span>
                    <img
                      src="static/img/icon/ca-work-1.2.svg"
                      alt=""
                    />
                  </span>
                </div>
                <div className="ca-work-ic-box-content">
                  <h4 className="ca-title fnw-600 text-white pt-24 pb-16">
                    <a href="/service-single">Planning and Strategy</a>
                  </h4>
                  <p>
                    Throughout the journey, our <br />
                    team monitors progress in real-
                    <br />
                    time, providing you with updates.
                  </p>
                </div>
              </div>
            </div> */}
      {/* working icon box */}
      {/* <div className="col-xl-3 col-lg-4 col-md-6 mb-30">
              <div
                className="ca-work-ic-box br-7 aos-init aos-animate"
                data-aos="fade-up"
                data-aos-duration={1200}
              >
                <div className="ca-work-ic-box-img">
                  <span>
                    <img
                      src="static/img/icon/ca-work1.3.svg"
                      alt=""
                    />
                  </span>
                </div>
                <div className="ca-work-ic-box-content">
                  <h4 className="ca-title fnw-600 text-white pt-24 pb-16">
                    <a href="/service-single">Real-Time Monitoring</a>
                  </h4>
                  <p>
                    Finally, we ensure timely and <br />
                    secure delivery of your goods, followed by a thorough review.
                  </p>
                </div>
              </div>
            </div> */}
      {/* working icon box */}
      {/* <div className="col-xl-3 col-lg-4 col-md-6 mb-30">
              <div
                className="ca-work-ic-box br-7 aos-init aos-animate"
                data-aos="fade-up"
                data-aos-duration={1400}
              >
                <div className="ca-work-ic-box-img">
                  <span>
                    <img
                      src="static/img/icon/ca-work1.4.svg"
                      alt=""
                    />
                  </span>
                </div>
                <div className="ca-work-ic-box-content">
                  <h4 className="ca-title fnw-600 text-white pt-24 pb-16">
                    <a href="/service-single">Secure Transportation</a>
                  </h4>
                  <p>
                    Trust our meticulous process to streamline your supply chain{" "}
                    <br /> and drive your business forward.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      {/* working section End */}


      {/* testimonial section start */}
      <section className="ca-testimonial-4 theme-black-bg-4 pt-100 pb-70 p-relative z-index-1">
        <div className="ca-shape ca-test-shape p-absolute">
          {/* <img src="static/img/shape/shape-1.1.webp" alt="" /> */}
          <img src="static/img/shape/shape-1.1 1 (1).webp" alt="" />
        </div>
        <div className="ca-service-shape p-absolute">
          {/* <img src="static/img/shape/ca-footer-shape3.1.webp" alt="" /> */}
          <img src="static/img/shape/ca-footer-shape3.1 11.webp" alt="" />
        </div>
        <div className="container">
          <div className="ca-blog-content-4 text-center mb-60" data-aos="fade-up" data-aos-duration="800">
            <h5 className="ca-section-subtitle subtitle-bg-9 text-white p-relative br-50">Customer Testimonial</h5>
            <h2 className="ca-section-title text-white fnw-600 pt-16 ca-text-cap">
              What Our Clients Say
            </h2>
          </div>

          <Swiper
            modules={[Pagination, Autoplay]}
            spaceBetween={30}
            slidesPerView={2}
            loop={true}
            autoplay={{ delay: 4000 }}
            pagination={{ clickable: true }}
            breakpoints={{
              0: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
            }}
          >
            {testimonials.map(({ id, quote, name, role, img }) => (
              <SwiperSlide key={id}>
                <div className="ca-testimonial-card-3 ca-testimonial-card-4 br-7">
                  <div className="ca-quote-4">
                    <img src="static/img/icon/ca-testimonialquote4.1.svg" alt="quote" />
                  </div>
                  <div className="ca-test-4-rating">
                    <div className="ca-ratings-4">
                      {[...Array(5)].map((_, i) => (
                        <span key={i}>
                          <i className="fa-solid fa-star"></i>
                        </span>
                      ))}
                    </div>
                  </div>
                  <div className="ca-test-4-content">
                    <p>“{quote}”</p>
                  </div>
                  <div className="ca-test-3-user mt-24">
                    <div className="ca-test-3-user-img">
                      <img src={img} alt={name} />
                    </div>
                    <div className="ca-test-4-user-name">
                      <h4 className="test-3-title">
                        <a href="#">{name}</a>
                      </h4>
                      <span>{role}</span>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>
      {/* testimonial section end */}


      {/* testimonial section start */}
      {/* <section className="ca-testimonial3  pt-100">
        <div className="container">
          <div
            className="ca-testimonial-content-3 ca-sec-content-3 text-center mb-60 aos-init aos-animate"
            data-aos="zoom-out-down"
            data-aos-duration={800}
          >
            <h5 className="ca-section-subtitle subtitle-bg-6 p-relative theme-color-3 br-50">
              Our Testimonial
            </h5>
            <h2 className="ca-section-title theme-black-3 fnw-600 pt-16 ca-text-cap">
              Trusted by Industry Leaders
            </h2>
            <p className="pt-16">
              Their testimonials highlight our commitment to overcoming logistical{" "}
              <br />
              challenges and delivering on our promises. Read on to discover.
            </p>
          </div>
          <div className="row">
            <div className="ca-testimonials">
              <div className="ca-testimonial-3">
                <div className="ca-testimonial-card-3 br-7">
                  <div className="ca-test-3-rating">
                    <div className="ca-ratings-3">
                      <span>
                        <i className="fa-solid fa-star" />
                      </span>
                      <span>
                        <i className="fa-solid fa-star" />
                      </span>
                      <span>
                        <i className="fa-solid fa-star" />
                      </span>
                      <span>
                        <i className="fa-solid fa-star" />
                      </span>
                      <span>
                        <i className="fa-solid fa-star" />
                      </span>
                    </div>
                    <div className="ca-rating-num-3">
                      <h4 className="ca-rating-title-3">
                        (5) <span>Rating</span>
                      </h4>
                    </div>
                  </div>
                  <div className="ca-test-3-content">
                    <h4 className="ca-test-title-3">
                      “Read about how our tailored solutions have helped businesses
                      achieve.”
                    </h4>
                    <p>
                      Our clients' satisfaction is our top priority,
                      <br /> and their feedback speaks volumes about our dedication
                      to excellence. We take immense <br /> pride in the positive
                      experiences shared by businesses across various industries who
                      rely <br /> on our transport and logistics expertise.
                    </p>
                  </div>
                  <div className="ca-test-3-user">
                    <div className="ca-test-3-user-img">
                      <span>
                        <img
                          src="static/img/testimonial/ca-testi3.1.webp"
                          alt=""
                        />
                      </span>
                    </div>
                    <div className="ca-test-3-user-name">
                      <h4 className="test-3-title">
                        <a href="#">Shevon Daniel</a>
                      </h4>
                      <span>Co-Founder</span>
                    </div>
                  </div>
                </div>
                <div className="ca-testimonial-card-3 br-7">
                  <div className="ca-test-3-rating">
                    <div className="ca-ratings-3">
                      <span>
                        <i className="fa-solid fa-star" />
                      </span>
                      <span>
                        <i className="fa-solid fa-star" />
                      </span>
                      <span>
                        <i className="fa-solid fa-star" />
                      </span>
                      <span>
                        <i className="fa-solid fa-star" />
                      </span>
                      <span>
                        <i className="fa-solid fa-star" />
                      </span>
                    </div>
                    <div className="ca-rating-num-3">
                      <h4 className="ca-rating-title-3">
                        (5) <span>Rating</span>
                      </h4>
                    </div>
                  </div>
                  <div className="ca-test-3-content">
                    <h4 className="ca-test-title-3">
                      “Hear from the businesses we support <br />
                      and their journey with our logistics.”
                    </h4>
                    <p>
                      At Cargon, client satisfaction is at the heart
                      <br /> of everything we do. We are proud to share <br /> the
                      positive experiences of our clients, whose testimonials
                      reflect or commitment delivering exceptional transport and
                      logistics solutions whether it's seamless international.
                    </p>
                  </div>
                  <div className="ca-test-3-user">
                    <div className="ca-test-3-user-img">
                      <span>
                        <img
                          src="static/img/testimonial/testimonial-2.1.webp"
                          alt=""
                        />
                      </span>
                    </div>
                    <div className="ca-test-3-user-name">
                      <h4 className="test-3-title">
                        <a href="#">Muhammad Waseem</a>
                      </h4>
                      <span>Co-Founder</span>
                    </div>
                  </div>
                </div>
                <div className="ca-testimonial-card-3 br-7">
                  <div className="ca-test-3-rating">
                    <div className="ca-ratings-3">
                      <span>
                        <i className="fa-solid fa-star" />
                      </span>
                      <span>
                        <i className="fa-solid fa-star" />
                      </span>
                      <span>
                        <i className="fa-solid fa-star" />
                      </span>
                      <span>
                        <i className="fa-solid fa-star" />
                      </span>
                      <span>
                        <i className="fa-solid fa-star" />
                      </span>
                    </div>
                    <div className="ca-rating-num-3">
                      <h4 className="ca-rating-title-3">
                        (5) <span>Rating</span>
                      </h4>
                    </div>
                  </div>
                  <div className="ca-test-3-content">
                    <h4 className="ca-test-title-3">
                      “Leading businesses share their success stories and why they
                      rely logistics.”
                    </h4>
                    <p>
                      Whether it's seamless international shipping, efficient
                      domestic transport, or specialized logistics services, our
                      clients consistently
                      <br /> praise our ability to meet and exceed their
                      expectations. They highlight our innovative approach, reliable
                      execution, &amp; dedicated.
                    </p>
                  </div>
                  <div className="ca-test-3-user">
                    <div className="ca-test-3-user-img">
                      <span>
                        <img
                          src="static/img/testimonial/ca-testi3.2.webp"
                          alt=""
                        />
                      </span>
                    </div>
                    <div className="ca-test-3-user-name">
                      <h4 className="test-3-title">
                        <a href="#">Shevon Daniel</a>
                      </h4>
                      <span>Co-Founder</span>
                    </div>
                  </div>
                </div>
                <div className="ca-testimonial-card-3 br-7">
                  <div className="ca-test-3-rating">
                    <div className="ca-ratings-3">
                      <span>
                        <i className="fa-solid fa-star" />
                      </span>
                      <span>
                        <i className="fa-solid fa-star" />
                      </span>
                      <span>
                        <i className="fa-solid fa-star" />
                      </span>
                      <span>
                        <i className="fa-solid fa-star" />
                      </span>
                      <span>
                        <i className="fa-solid fa-star" />
                      </span>
                    </div>
                    <div className="ca-rating-num-3">
                      <h4 className="ca-rating-title-3">
                        (5) <span>Rating</span>
                      </h4>
                    </div>
                  </div>
                  <div className="ca-test-3-content">
                    <h4 className="ca-test-title-3">
                      “Read about how our tailored solutions have helped businesses
                      achieve.”
                    </h4>
                    <p>
                      Our clients' satisfaction is our top priority,
                      <br /> and their feedback speaks volumes about our dedication
                      to excellence. We take immense <br /> pride in the positive
                      experiences shared by businesses across various industries who
                      rely <br /> on our transport and logistics expertise.
                    </p>
                  </div>
                  <div className="ca-test-3-user">
                    <div className="ca-test-3-user-img">
                      <span>
                        <img
                          src="static/img/testimonial/ca-testi3.1.webp"
                          alt=""
                        />
                      </span>
                    </div>
                    <div className="ca-test-3-user-name">
                      <h4 className="test-3-title">
                        <a href="#">Shevon Daniel</a>
                      </h4>
                      <span>Co-Founder</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      {/* testimonial section end */}


      {/* choose section start */}
      <section className="ca-about-3 cream-bg-3 pt-100 pb-70">

        <div className="container subtitle-container">
          <h5 className="ca-section-subtitle subtitle-bg-6 p-relative theme-color-3 br-50 txt-ce">
            Our Vision & Commitment
          </h5>
          <h2 className="ca-section-title theme-black-3 fnw-600 pt-16 ca-text-cap txt-ce">
            Karmyogi Key Values
          </h2><br />
          <div className="row">
            <div className="col-lg-6 mb-30 mob-6 ">
              <div className="ca-choose-content3">
                {/* <div className="ca-about-content-3 ca-sec-content-3">
              </div><br /> */}
                <div className="row">
                  <div className="ca-iner-ch-box-content mb-40 mb-40-sec">
                    <h4 className="ca-title fnw-600 theme-black-2 pb-16">
                      Price Commitment
                    </h4>
                    <p>
                      The price is the most important part. We always insist our buyers, that they'll get best rates for the products.
                    </p>
                  </div>
                  <div className="ca-iner-ch-box-content mb-40 mb-40-sec">
                    <h4 className="ca-title fnw-600 theme-black-2 pb-16">
                      Best Services
                    </h4>
                    <p>
                      We are commited for a long mutual business relationship, and we know that it will come from best service only.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6 mb-30">
              <div className="ca-choose-content3">
                <div className="row">
                  <div className="ca-iner-ch-box-content mb-40 mb-40-sec">
                    <h4 className="ca-title fnw-600 theme-black-2 pb-16">
                      Quality
                    </h4>
                    <p>
                      Due to the support of our highly skilled and experienced workforce, we product best quality products.
                    </p>
                  </div>
                  <div className="ca-iner-ch-box-content mb-40 mb-40-sec">
                    <h4 className="ca-title fnw-600 theme-black-2 pb-16">
                      Delivery Time
                    </h4>
                    <p>
                      We always try to, not fail in our any of our delivery commitment, hence our all customers are very satisfied with this statement.
                    </p>
                  </div>

                </div>

              </div>
            </div>

            {/* <div className="ca-about-3-btn">
              <a
                href="#"
                className="ca-btn-primary-3 theme-bg-3 text-white br-50"
              >
                Learn More
                <span>
                  <i className="fa-solid fa-angle-right" />
                </span>
              </a>
            </div> */}
          </div>
        </div>
      </section>
      {/* choose section end */}



      {/* sponsor section start */}
      <section className="ca-sponsor-area pt-100 pb-70 hide-m">
        <div className="container text-center mb-60">
          <h5 className="ca-section-subtitle subtitle-bg-8 p-relative theme-black-4 br-50">
            Happy Client And Sponsor
          </h5>
          <h2 className="ca-section-title theme-black-4 fnw-600 pt-16 ca-text-cap">
            Trusted By Our 500+ Clients
          </h2>
        </div>

        {/* Slider moving to right */}
        <Slider {...sliderSettings} className="ca-brand-slides mb-24">
          {logos1.map((logo, index) => (
            <div className="ca-brand-item" key={index}>
              <img src={logo} alt="" />
            </div>
          ))}
        </Slider>

        {/* Slider moving to left */}
        <Slider {...sliderSettings} className="ca-brand-slides-2" rtl>
          {logos2.map((logo, index) => (
            <div className="ca-brand-item" key={index}>
              <img src={logo} alt="" />
            </div>
          ))}
        </Slider>
      </section>
      {/* sponsor section end */}


      {/* contact-section start */}
      {/* <section class="contact-3-area cream-bg-3 pt-100 pb-70">
                          <div class="container">
                              <div class="ca-blog-content-3 ca-sec-content-3 text-center mb-60 aos-init aos-animate"
                                  data-aos="zoom-out-down" data-aos-duration="1000">
                                  <h5 class="ca-section-subtitle subtitle-bg-6 p-relative theme-color-3 br-50">Contact Us</h5>
                                  <h2 class="ca-section-title theme-black-3 fnw-600 pt-16 ca-text-cap"> Trusted by Industry Leaders</h2>
                                  <p class="pt-16">Gain insights into effective warehouse management strategies that<br> maximize space,
                                      improve accuracy, and boost productivity. </p>
                              </div>
                              <div class="row align-items-center">
                                  <div class="col-xl-6 mb-30">
                                      <div class="ca-contact-from w-bg ca-contact-from-3 aos-init aos-animate" data-aos="fade-right"
                                          data-aos-duration="1200">
                                          <div class="ca-contact-content-3">
                                              <h4 class="ca-contact-title-2 theme-black-2 fnw-600">Send Us A Message</h4>
                                              <p class="pt-16 pb-24">As a fellow small business owner, we know the fulfillment that an a
                                                  best to comes from running & own business contact our service to Cargon.</p>
                                          </div>
                                          <form action="#">
                                              <div class="row">
                                                  <div class="col-md-6 mb-20">
                                                      <input type="text" placeholder="First Name">
                                                  </div>
                                                  <div class="col-md-6 mb-20">
                                                      <input type="text" placeholder="Last Name">
                                                  </div>
                                                  <div class="col-md-6 mb-20">
                                                      <input type="tel" placeholder="Phone Number">
                                                  </div>
                                                  <div class="col-md-6 mb-20">
                                                      <input type="email" placeholder="Email Address">
                                                  </div>
                                                  <div class="col-md-12 mb-20">
                                                      <select class="nice-select wide ca-select">
                                                          <option data-display="Service Type">Nothing</option>
                                                          <option value="1">01</option>
                                                          <option value="2">02</option>
                                                          <option value="3">03</option>
                                                          <option value="4">04</option>
                                                      </select>
                                                  </div>
                                                  <div class="col-md-12 mb-20">
                                                      <textarea name="message" id="message" placeholder="Message"></textarea>
                                                  </div>
                                                  <div class="submit-btn">
                                                      <button class="ca-btn-primary-3 theme-bg-3 text-white br-50" type="submit"
                                                          value="submit"> Send Message<span><i
                                                              class="fa-solid fa-angle-right"></i></span></button>
                                                  </div>
                                              </div>
                                          </form>
                                      </div>
                                  </div>
                                  <div class="col-xl-6 mb-30">
                                      <div class="ca-form-loca-3 ml-50 aos-init aos-animate" data-aos="fade-left"
                                          data-aos-duration="1400"> */}
      {/* single box item */}
      {/*  <div class="ca-location-3 mb-20">
                                              <div class="ca-location-icbox">
                                                  <div class="ca-location-icbox-img">
                                                      <span><img src="static/img/icon/ca-location3.1.svg" alt=""></span>
                                                  </div>
                                                  <div class="ca-location-icbox-text">
                                                      <h4 class="ca-title fnw-600 theme-black-3 pb-12">Contact Us</h4>
                                                      <p>198 West 21th Street,New York NY City 1010 <br> freightexpress@mail.com</p>
                                                  </div>
                                              </div>
                                          </div> */}
      {/* single box item */}
      {/*  <div class="ca-location-3 mb-20">
                                              <div class="ca-location-icbox">
                                                  <div class="ca-location-icbox-img">
                                                      <span><img src="static/img/icon/ca-location3.2.svg" alt=""></span>
                                                  </div>
                                                  <div class="ca-location-icbox-text">
                                                      <h4 class="ca-title fnw-600 theme-black-3 pb-12">Call or Text</h4>
                                                      <a href="tel:123-456-7890">123-456-7890</a>
                                                  </div>
                                              </div>
                                          </div> */}
      {/* single box item */}
      {/*  <div class="ca-location-3 mb-20">
                                              <div class="ca-location-icbox">
                                                  <div class="ca-location-icbox-img">
                                                      <span><img src="static/img/icon/ca-location3.3.svg" alt=""></span>
                                                  </div>
                                                  <div class="ca-location-icbox-text">
                                                      <h4 class="ca-title fnw-600 theme-black-3 pb-12">Send Email</h4>
                                                      <a
                                                          href="mailto:infotransportlogistics@gmail.com">infotransportlogistics@gmail.com</a>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </section> */}
      {/* contact-section end */}

      {/* contact-section start */}
      <section className="contact-3-area cream-bg-3 pt-100 pb-70">
          <div className="container">
            <div
              className="ca-blog-content-3 ca-sec-content-3 text-center mb-60 aos-init aos-animate"
              data-aos="zoom-out-down"
              data-aos-duration="1000"
            >
              <h5 className="ca-section-subtitle subtitle-bg-6 p-relative theme-color-3 br-50">
                Contact Us
              </h5>
              <h2 className="ca-section-title theme-black-3 fnw-600 pt-16 ca-text-cap">
                Trusted by Industry Leaders
              </h2>
              <p className="pt-16">
                Gain insights into effective warehouse management strategies that
                <br /> maximize space, improve accuracy, and boost productivity.
              </p>
            </div>

            <div className="row align-items-center">
              <div className="col-xl-6 mb-30">
                <div
                  className="ca-contact-from w-bg ca-contact-from-3 aos-init aos-animate"
                  data-aos="fade-right"
                  data-aos-duration="1200"
                >
                  <div className="ca-contact-content-3">
                    <h4 className="ca-contact-title-2 theme-black-2 fnw-600">
                      Send Us A Message
                    </h4>
                    <p className="pt-16 pb-24">
                      As a fellow small business owner, we know the fulfillment that comes
                      from running & owning a business. Contact our service at karmyogi Enterprise.
                    </p>
                  </div>

                  {/* ✅ React Controlled Form */}
                <form onSubmit={handleSubmit}>
                  <div className="row">

                    <div className="col-lg-6 mb-20">
                      <input type="text" name="first_name" placeholder="First Name" value={formData.first_name} onChange={handleChange} required />
                    </div>

                    {/* <div className="col-lg-6 mb-20">
                      <input type="text" name="last_name" placeholder="Last Name" value={formData.last_name} onChange={handleChange} required />
                    </div> */}

                    <div className="col-lg-6 mb-20">
                      {/* <input type="tel" name="number" placeholder="phone Number" value={formData.number} onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')} onChange={handleChange} required /> */}
                      <input
                          type="tel"
                          name="number"
                          placeholder="Phone Number"
                          value={formData.number}
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(/[^0-9]/g, "").slice(0, 10);
                            handleChange(e); // state update ensure
                          }}
                          required
                        />
                    </div>

                    <div className="col-lg-6 mb-20">
                      <input type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange} required />
                    </div>

                    {/* <div className="col-lg-6 mb-20">
                      <input type="tel" name="number" placeholder="phone Number" value={formData.number} onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')} onChange={handleChange} required />
                    </div> */}

                    <div className="col-lg-6 mb-20">
                      <select name="service_type" className="ca-select" value={formData.service_type} onChange={handleChange} required>
                        <option value="">Select Service</option>
                        <option value="U Bend">U Bend</option>
                        <option value="C Bend">C Bend</option>
                        <option value="Y Bend">Y Bend</option>
                        <option value="Copper Filter">Copper Filter</option>
                        <option value="Copper Tripod">Copper Tripod</option>
                        <option value="Copper Tee">Copper Tee</option>
                        <option value="Copper Elbow">Copper Elbow</option>
                        <option value="Copper Cap">Copper Cap</option>
                        <option value="Copper Straight Pipe">Copper Straight Pipe</option>
                        <option value="Copper Pancake">Copper Pancake</option>
                        <option value="Copper Tube LWC">Copper Tube LWC</option>
                        <option value="Alluminum For Fins">Alluminum For Fins</option>
                        <option value="Copper Foil">Copper Foil</option>
                        <option value="Brazzing Road">Brazzing Road</option>
                        <option value="NRV Valves">NRV Valves</option>
                        <option value="Distributors">Distributors</option>
                      </select>
                    </div>
                    
                     {/* <div className="col-lg-6 mb-20">
                      <input type="tel" name="number" placeholder="phone Number" value={formData.number} onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')} onChange={handleChange} required />
                    </div> */}

                    <div className="col-lg-12 mb-20">
                      {/* <textarea name="message" placeholder="Message" value={formData.message} onChange={handleChange} required /> */}
                      <textarea name="message" placeholder="Message" value={formData.message} onChange={handleChange} required ></textarea>

                    </div>

            


                  </div>

                  <div className="ca-radion-btn">
                    <input type="checkbox" id="saveinfo" name="save_info" checked={formData.save_info} onChange={handleChange} />
                    <label htmlFor="saveinfo">Save information in browser</label>
                  </div>

                  <div className="ca-blg-sen-btn text-start">
                    <button type="submit" className="ca-btn-primary-3 theme-bg-3 text-white br-50" disabled={loading}>
                      {loading ? "Submitting..." : "Submit Now"} <span><i className="fa-solid fa-angle-right" /></span>
                    </button>
                  </div>

                  {/* {responseMsg && <p className="pt-3">{responseMsg}</p>} */}
                  {responseMsg && (
                    <p
                      className={`pt-3 ${
                        responseMsg.includes("Thank you")
                          ? "text-success"
                          : "text-danger"
                      }`}
                    >
                      {responseMsg}
                    </p>
                  )}


                </form>
                </div>
              </div>

              {/* Right side contact info */}
              <div className="col-xl-6 mb-30">
                <div
                  className="ca-form-loca-3 ml-50 aos-init aos-animate"
                  data-aos="fade-left"
                  data-aos-duration="1400"
                >
                  {/* contact items */}
                  <div className="ca-location-3 mb-20">
                    <div className="ca-location-icbox">
                      <div className="ca-location-icbox-img">
                        <span>
                          <img src="static/img/icon/ca-location3.1.svg" alt="" />
                        </span>
                      </div>
                      <div className="ca-location-icbox-text">
                        <h4 className="ca-title fnw-600 theme-black-3 pb-12">Contact Us</h4>
                        <p>91 Shubham Industrial Estate Puna-Valthan Road, Surat</p>
                      </div>
                    </div>
                  </div>

                  <div className="ca-location-3 mb-20">
                    <div className="ca-location-icbox">
                      <div className="ca-location-icbox-img">
                        <span>
                          <img src="static/img/icon/ca-location3.2.svg" alt="" />
                        </span>
                      </div>
                      <div className="ca-location-icbox-text">
                        <h4 className="ca-title fnw-600 theme-black-3 pb-12">Call or Text</h4>
                        <a href="tel:+916352099433">+91 6352 099 433</a>
                      </div>
                    </div>
                  </div>

                  <div className="ca-location-3 mb-20">
                    <div className="ca-location-icbox">
                      <div className="ca-location-icbox-img">
                        <span>
                          <img src="static/img/icon/ca-location3.3.svg" alt="" />
                        </span>
                      </div>
                      <div className="ca-location-icbox-text">
                        <h4 className="ca-title fnw-600 theme-black-3 pb-12">Send Email</h4>
                        <a href="mailto:tarak@karmyogienterprise.com">tarak@karmyogienterprise.com</a>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </section>
      {/* contact-section end */}


      




      {/* blog section start */}
      {/* <section className="ca-blog pt-100 pb-70">
        <div className="container">
          <div
            className="ca-blog-content-3 ca-sec-content-3 text-center mb-60 aos-init aos-animate"
            data-aos="fade-up"
            data-aos-duration={800}
          >
            <h5 className="ca-section-subtitle subtitle-bg-6 p-relative theme-color-3 br-50">
              Our Blog
            </h5>
            <h2 className="ca-section-title theme-black-3 fnw-600 pt-16 ca-text-cap">
              {" "}
              Best Practices and Strategies
            </h2>
            <p className="pt-16">
              Gain insights into effective warehouse management strategies that
              <br /> maximize space, improve accuracy, and boost productivity.{" "}
            </p>
          </div>
          <div className="row"> */}
      {/* single-blog-item */}
      {/* <div className="col-xl-4 col-md-6 mb-30">
              <div
                className="ca-team-box ca-blog-box-3 cream-bg-3 br-7 fix p-relative z-index-1 aos-init aos-animate"
                data-aos="fade-right"
                data-aos-duration={800}
              >
                <div className="ca-team-img">
                  <a href="/blog-single">
                    <img
                      className="w-100"
                      src="/static/img/blog/ca-blog-1.2.webp"
                      alt=""
                    />
                  </a>
                </div>
                <div className="ca-blog-date-3">
                  <a href="#" className="blg-date-3">
                    March 21, 2024
                  </a>
                </div>
                <div className="ca-blog-box-content ca-blog-box-content-3">
                  <div className="ca-b-meta"> */}
      {/* blog meta box */}
      {/* <a href="#" className="ca-blog-meta ca-blog-meta-3">
                      <div className="ca-meta-icon">
                        <span>
                          <img
                            src="static/img/icon/user-1.1.svg"
                            alt=""
                          />
                        </span>
                      </div>
                      <div className="ca-meta-title">
                        <span>Henry Nicolls</span>
                      </div>
                    </a> */}
      {/* blog meta box */}
      {/* <a href="#" className="ca-blog-meta ca-blog-meta-3">
                      <div className="ca-meta-icon">
                        <span>
                          <img
                            src="static/img/icon/tag-1.1.svg"
                            alt=""
                          />
                        </span>
                      </div>
                      <div className="ca-meta-title">
                        <span>Transport &amp; Logistics</span>
                      </div>
                    </a>
                  </div>
                  <h4 className="ca-blog-title ca-blog-title-3 fnw-600">
                    <a href="/blog-single">
                      Optimizing Last-Mile Delivery: Strategies for Success
                    </a>
                  </h4>
                  <p className="pt-16 pb-18">
                    Delve into the challenges of last-mile delivery <br />
                    and explore strategies to overcome them.
                  </p>
                  <div className="blog-3-rearmore">
                    <a href="/blog-single" className="read-more3">
                      Read More{" "}
                      <span>
                        <i className="fa-solid fa-angle-right" />
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div> */}
      {/* single-blog-item */}
      {/* <div className="col-xl-4 col-md-6 mb-30">
              <div
                className="ca-team-box ca-blog-box-3 cream-bg-3 br-7 fix p-relative z-index-1  aos-init aos-animate"
                data-aos="fade-up"
                data-aos-duration={1000}
              >
                <div className="ca-team-img">
                  <a href="/blog-single">
                    <img
                      className="w-100"
                      src="static/img/blog/ca-blog-1.3.webp"
                      alt=""
                    />
                  </a>
                </div>
                <div className="ca-blog-date-3">
                  <a href="#" className="blg-date-3">
                    March 20, 2024
                  </a>
                </div>
                <div className="ca-blog-box-content ca-blog-box-content-3">
                  <div className="ca-b-meta"> */}
      {/* blog meta box */}
      {/* <a href="#" className="ca-blog-meta ca-blog-meta-3">
                      <div className="ca-meta-icon">
                        <span>
                          <img
                            src="static/img/icon/user-1.1.svg"
                            alt=""
                          />
                        </span>
                      </div>
                      <div className="ca-meta-title">
                        <span>Henry Nicolls</span>
                      </div>
                    </a> */}
      {/* blog meta box */}
      {/* <a href="#" className="ca-blog-meta ca-blog-meta-3">
                      <div className="ca-meta-icon">
                        <span>
                          <img
                            src="static/img/icon/tag-1.1.svg"
                            alt=""
                          />
                        </span>
                      </div>
                      <div className="ca-meta-title">
                        <span>Transport &amp; Logistics</span>
                      </div>
                    </a>
                  </div>
                  <h4 className="ca-blog-title ca-blog-title-3 fnw-600">
                    <a href="/blog-single">
                      Handling Project Cargo: Expert
                      <br /> Tips and Strategies
                    </a>
                  </h4>
                  <p className="pt-16 pb-18">
                    Get expert tips on managing project cargo <br /> logistics. From
                    planning and coordination.
                  </p>
                  <div className="blog-3-rearmore">
                    <a href="/blog-single" className="read-more3">
                      Read More{" "}
                      <span>
                        <i className="fa-solid fa-angle-right" />
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div> */}
      {/* single-blog-item */}
      {/* <div className="col-xl-4 col-md-6 mb-30">
              <div
                className="ca-team-box ca-blog-box-3 cream-bg-3 br-7 fix p-relative z-index-1 aos-init aos-animate"
                data-aos="fade-left"
                data-aos-duration={1200}
              >
                <div className="ca-team-img">
                  <a href="/blog-single">
                    {" "}
                    <img
                      className="w-100"
                      src="static/img/blog/ca-blog-1.1.webp"
                      alt=""
                    />
                  </a>
                </div>
                <div className="ca-blog-date-3">
                  <a href="#" className="blg-date-3">
                    March 18, 2024
                  </a>
                </div>
                <div className="ca-blog-box-content ca-blog-box-content-3">
                  <div className="ca-b-meta"> */}
      {/* blog meta box */}
      {/* <a href="#" className="ca-blog-meta ca-blog-meta-3">
                      <div className="ca-meta-icon">
                        <span>
                          <img
                            src="static/img/icon/user-1.1.svg"
                            alt=""
                          />
                        </span>
                      </div>
                      <div className="ca-meta-title">
                        <span>Henry Nicolls</span>
                      </div>
                    </a> */}
      {/* blog meta box */}
      {/* <a href="#" className="ca-blog-meta ca-blog-meta-3">
                      <div className="ca-meta-icon">
                        <span>
                          <img
                            src="static/img/icon/tag-1.1.svg"
                            alt=""
                          />
                        </span>
                      </div>
                      <div className="ca-meta-title">
                        <span>Transport &amp; Logistics</span>
                      </div>
                    </a>
                  </div>
                  <h4 className="ca-blog-title ca-blog-title-3 fnw-600">
                    <a href="/blog-single">
                      The Importance of Reliable Freight Forwarding Services
                    </a>
                  </h4>
                  <p className="pt-16 pb-18">
                    Learn practical strategies for optimizing your
                    <br /> supply chain operations, improve delivery.
                  </p>
                  <div className="blog-3-rearmore">
                    <a href="/blog-single" className="read-more3">
                      Read More{" "}
                      <span>
                        <i className="fa-solid fa-angle-right" />
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      {/* blog section end */}
      

<Modal
  show={showModal}
  onHide={() => setShowModal(false)}
  centered
  size="md"
  dialogClassName="new-modal"
>
  <div className="modal-wrapper">

    {/* Header */}
    <div className="modal-top-bar">
      <h5 className="modal-title-custom">{modalContent.title}</h5>
      <button className="close-btn" onClick={() => setShowModal(false)}>×</button>
    </div>

    {/* Body */}
    <div className="modal-body-custom">

      <form onSubmit={handlePopupSubmit}>

        <div className="field">
          <label>Name</label>
          <input
            type="text"
            value={popupFormData.name}
            onChange={(e) =>
              setPopupFormData({ ...popupFormData, name: e.target.value })
            }
            required
          />
        </div>

        <div className="field">
          <label>Phone Number</label>
          <input
            type="text"
            value={popupFormData.phone}
            onChange={(e) => {
              const onlyNumbers = e.target.value.replace(/\D/g, "");
              if (onlyNumbers.length <= 10) {
                setPopupFormData({ ...popupFormData, phone: onlyNumbers });
              }
            }}
            required
          />
          {popupFormData.phone.length > 0 &&
            popupFormData.phone.length < 10 && (
              <small style={{ color: "red" }}>
                Phone number must be 10 digits
              </small>
            )}
        </div>

        <div className="field">
          <label>Notes</label>
          <textarea
            value={popupFormData.message}
            onChange={(e) =>
              setPopupFormData({ ...popupFormData, message: e.target.value })
            }
            required
          ></textarea>
        </div>

        <button type="submit" className="submit-modern-btn">
          {popupLoading ? "Submitting..." : "Submit"}
        </button>
      </form>

      {popupResponseMsg && (
        <p className="response-message">{popupResponseMsg}</p>
      )}
    </div>
  </div>
</Modal>

        
          
    </main>
</>
  );
}

export default Home;
